define(function (require) {
    var avalon = require('avalon'),
        tool = require('toolLoaderPC');

    var hiddenValues;

    var vmodel = avalon.define({
        $id: 'applyRefundResultController',
        refund: null,

        refund_flow_1: null, // 申请退款信息
        refund_flow_2: null, // 同意退款信息
        refund_flow_3: null // 确定退款信息
    });

    return {
        init: function () {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            vmodel.refund = hiddenValues.refund;

            if (hiddenValues.refund_flow[0]) { vmodel.refund_flow_1 = hiddenValues.refund_flow[0] }
            if (hiddenValues.refund_flow[1]) { vmodel.refund_flow_2 = hiddenValues.refund_flow[1] }
            if (hiddenValues.refund_flow[2]) { vmodel.refund_flow_3 = hiddenValues.refund_flow[2] }

            // console.log(hiddenValues)
        },
        clear: function () {}
    };
});



// WEBPACK FOOTER //
// ./src/js_modules/applyRefundResultController.js